import LecomRefluxEvents from '../../reflux/events/lecom_reflux_events';

export default Object.assign({}, LecomRefluxEvents, {
	SEARCH: 'SEARCH',
	PAGINATE: 'PAGINATE',
	UPDATE_FORM_VALUES: 'UPDATE_FORM_VALUES'
});
